import { render, staticRenderFns } from "./AnexoVeinti.vue?vue&type=template&id=22d9633e&scoped=true&"
import script from "./AnexoVeinti.vue?vue&type=script&lang=js&"
export * from "./AnexoVeinti.vue?vue&type=script&lang=js&"
import style0 from "./AnexoVeinti.vue?vue&type=style&index=0&id=22d9633e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9633e",
  null
  
)

export default component.exports